import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import moment from 'moment'
import { makeStyles } from '@material-ui/styles'
import {
  Card,
  CardActions,
  CardContent,
  Typography,
  Divider,
  Button,
  LinearProgress,
  Avatar
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {},
  details: {
    display: 'flex'
  },
  avatar: {
    marginLeft: 'auto',
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0
  },
  progress: {
    marginTop: theme.spacing(2)
  },
  uploadButton: {
    marginRight: theme.spacing(2)
  }
}))

const AccountProfile = props => {
  const { className, ...rest } = props

  const classes = useStyles()

  const user = {
    name: 'Trung Ung',
    city: 'Helsinki',
    country: 'Finland',
    timezone: 'GTM-4',
    avatar: 'https://i.dlpng.com/static/png/1451009_thumb.png'
  }

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <div className={classes.details}>
          <div>
            <Typography gutterBottom variant="h2">
              Name: Trung Ung
            </Typography>
            <Typography
              className={classes.locationText}
              color="textSecondary"
              variant="body1">
              Company: MeetingPackage.com
            </Typography>
            <Typography
              className={classes.dateText}
              color="textSecondary"
              variant="body1">
              Email: trung.ung@meetingpackage.com
            </Typography>
            <Typography
              className={classes.phoneText}
              color="textSecondary"
              variant="body1">
              Phone: 1234567890
            </Typography>
          </div>
          <Avatar className={classes.avatar} src={user.avatar} />
        </div>
        <div className={classes.progress}>
          <Typography variant="body1">Profile Completeness: 100%</Typography>
          <LinearProgress value={100} variant="determinate" />
        </div>
      </CardContent>
      <Divider />
      <CardActions>
        <Button className={classes.uploadButton} color="primary" variant="text">
          Upload picture
        </Button>
        <Button variant="text">Remove picture</Button>
      </CardActions>
    </Card>
  )
}

AccountProfile.propTypes = {
  className: PropTypes.string
}

export default AccountProfile
